export default __webpack_public_path__ + "static/media/arrow-left.8e0b8e8c.svg";